import React from 'react';

// ── S27 — Cierre (Spec V4) ───────────────────────────────────────────────────
// Fondo #3E246B, logo centrado, KPI badge teal, frases de cierre

const ManCrossPageClose = () => (
    <div className="mgcr-close-page">
        <img src="/talentha-blanco.png" alt="Talentha" className="mgcr-close-logo" />
        
        <div className="mgcr-close-kpi-block">
            <p className="mgcr-close-kpi-title">KPI de la próxima medición:</p>
            <p className="mgcr-close-kpi-badge">Cero equipos con IVC Nivel 3</p>
        </div>
        
        <div className="mgcr-close-divider" />

        <p className="mgcr-close-main-phrase">
            La seguridad tiene dos momentos: 
            <br />
            antes y después del accidente.
            <br />
            <br />
            Este informe existe para actuar <strong style={{ color: 'var(--managerial-teal)' }}>ANTES</strong>.
        </p>

        <p className="mgcr-close-sub-phrase">Tu cuidado importa. Tu seguridad importa.</p>

    </div>
);

export default ManCrossPageClose;
